export const gridVideoModeSlickSettings = {
  infinite: true,
  arrows: false,
  slidesToShow: 5,
  slidesToScroll: 5,
  paginationName: 'related-snapshot-pagination',
  draggable: false
};

export const factoidSlickSettings = {
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  adaptiveHeight: true,
  arrows: false,
  paginationName: 'facts-pagination'
}

export const youtubeCarouselSlickSettings = {
  paginationName: 'youtube-videos-pagination',
  arrows: false,
  lazyLoad: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  infinite: true
}

export const blogCarouselSlickSettings = {
  arrows: false,
  paginationName:'blog-pagination',
  lazyLoad: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  initialSlide: 0,
  infinite: true
}

export const channelSliderSlickSettings = {
  infinite: true,
  arrows: false,
  slidesToShow: 9,
  slidesToScroll: 9,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1435,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 8,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1286,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 7,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1140,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 6,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 5,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3
      }
    }
  ]
}

export const camGroupCarouselSlickSettings = {
  infinite: true,
  centerMode: false,
  slidesToShow: 10,
  slidesToScroll: 1,
  initialSlide: 0,
  swipe: true,
  swipeToSlide: true,
  adaptiveHeight: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 3100,
      settings: {
        slidesToShow: 15,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 2600,
      settings: {
        slidesToShow: 14,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 2300,
      settings: {
        slidesToShow: 13,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 2100,
      settings: {
        slidesToShow: 12,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 1900,
      settings: {
        slidesToShow: 11,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 1700,
      settings: {
        slidesToShow: 9,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 1500,
      settings: {
        slidesToShow: 8,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
      }
    },
    {
      breakpoint: 1300,
      settings: {
        slidesToShow: 7,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
      }
    },
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 5,
        slidesToScroll: 1,
        swipeToSlide: true,
        infinite: true,
      }
    },
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        swipeToSlide: true
      }
    }
  ]
}
